import { render } from "./App.vue?vue&type=template&id=b9879ca8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b9879ca8&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__